import { API_URL } from 'app/config/envVariables';
import { ExportEntity } from 'features/ExportModal/model/types';

export const getExportEnityUrl = (entity: ExportEntity): string => {
  switch (entity) {
    case ExportEntity.BOX:
      return `${API_URL}/boxes/export`;
    case ExportEntity.LEAD:
      return `${API_URL}/leads/export`;
    case ExportEntity.CONTRACT:
      return `${API_URL}/contracts/export`;
    case ExportEntity.INVOICE:
      return `${API_URL}/billing-documents/invoices/export`;
    case ExportEntity.CREDIT_NOTE:
      return `${API_URL}/billing-documents/credit-notes/export`;
    case ExportEntity.INSURANCE:
      return `${API_URL}/billing-documents/invoices/insurance/export`;
    case ExportEntity.DEPOSIT:
      return `${API_URL}/billing-documents/deposits/export`;
    case ExportEntity.USER:
      return `${API_URL}/users/export`;
    case ExportEntity.OCCUPANCY_BOX:
      return `${API_URL}/warehouses/statistics/boxes/occupancy/export`;
    case ExportEntity.INCOME_STATISTICS:
      return `${API_URL}/warehouses/statistics/income/export`;
  }
};
